<nav class="navbar navbar-default navbar-static-top">
  <div class="container-fluid">
    <div class="navbar-header">
      <a class="navbar-brand navbar-brand-image">
        <img src="/assets/logo.svg" alt="Leada-Logo">
      </a>
    </div>
  </div>
</nav>
